import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Linkify from 'react-linkify'
import styled from 'styled-components'
import { Link } from 'gatsby'
import { Box, Flex, DesktopContainer } from './ui/BuildingBlocks'
import Button from './ui/Button'
import Spinner from './ui/Spinner'
import { colors, smallBoxShadow } from './ui/helpers.js'
import { urlToString } from './ui/formatters.js'
import countryToIso2 from '../../constants/countryToIso2'
import { translate, countryTranslate, activeCountries } from '../../constants/translations'

import { H1, H2, H3, SeoH2, SeoH4, Span, Text, LinkSpan } from './ui/Font'
import OnlineIcon from './ui/OnlineIcon'
import Image from './ui/Image'

const TextButton = styled(Text)`
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  padding: 24px;
`

const LinkText = ({ url, label }) => {
  return (
    <Link to={url}>
      <TextButton color="white">{label}</TextButton>
    </Link>
  )
}

const Footer = ({ iso2 }) => {
  return (
    <>
      <Flex height="200px" bg={colors.darkGrey} flexDirection="column" justifyContent="space-between">
        <Flex justifyContent="center">
          <LinkText url={`${iso2 === 'en' ? '' : `/${iso2}`}/`} label={translate(`Home`, 'home', iso2)} />
          <LinkText url={`/about/`} label={translate(`About`, 'about', iso2)} />
          <LinkText url={`/privacy-policy/`} label={translate(`Privacy Policy`, 'privacypolicy', iso2)} />
        </Flex>
        <Flex justifyContent="center" mb="20px">
          <Text color="white">
            <Span color="white" fontSize="26px" fontWeight="bold" mr="20px">
              WERECEIVESMS
            </Span>{' '}
            © {new Date().getFullYear()}
          </Text>
        </Flex>
      </Flex>
    </>
  )
}
export default Footer
